

<script>
	import options from './AboutUsSpot.options'
	export default options
</script>

<template>
    <article class="nlx-about-us-spot">

        <template v-if="props.href">
            <a :href="props.href" class="nlx-about-us-spot__click-layer"></a> 
        </template>

        <div class="nlx-about-us-spot__image-container">
            <img :src="props.imageHref" :alt="props.title"/>
        </div>
        <p class="nlx-about-us-spot__paragraph">{{props.title}}</p>

    </article>
</template>
